import * as Yup from "yup";

import { validationMsgs } from "@sso/constant";
import { LicenceType, PaymentType, PricingRuleKeys, SoftwareLicenceKeys, SoftwareLicenceSummaryKeys } from "@sso/types";

const pricingRuleValidation = Yup.object().shape({
  [PricingRuleKeys.PRICE]: Yup.number().required("required"),
  [PricingRuleKeys.MAX_RANGE]: Yup.number().when("isLast", {
    is: false,
    then: Yup.number().required("required").moreThan(Yup.ref(PricingRuleKeys.MIN_RANGE), "Min > Max"),
    otherwise: Yup.number(),
  }),
});

export const generalStepSchema = Yup.object().shape({
  [SoftwareLicenceSummaryKeys.NAME]: Yup.string().required(validationMsgs.required),
  [SoftwareLicenceSummaryKeys.LICENCE_TYPE]: Yup.string().required(validationMsgs.required),
  [SoftwareLicenceSummaryKeys.PAYMENT_TYPE]: Yup.string().required(validationMsgs.required),
});

export const specificStepSchema = Yup.object().shape({
  defaultConcurrentUsers: Yup.number().when([SoftwareLicenceSummaryKeys.LICENCE_TYPE], {
    is: (value: string) => value === LicenceType.CONCURRENT.toString(),
    then: Yup.number().required(validationMsgs.required),
    otherwise: Yup.number(),
  }),
  expiryTimeValue: Yup.number().when("paymentType", {
    is: (value: string) => value !== PaymentType.PaymentOnAccount.toString(),
    then: Yup.number().required(validationMsgs.required),
    otherwise: Yup.number(),
  }),
  expiryTimeUnit: Yup.string().when("paymentType", {
    is: (value: string) => value !== PaymentType.PaymentOnAccount.toString(),
    then: Yup.string().required(validationMsgs.required),
    otherwise: Yup.string(),
  }),
});

export const pricingStepSchema = Yup.object().shape({
  pricingRules: Yup.array().when("paymentType", {
    is: (value: string) => value !== PaymentType.Free.toString(),
    then: Yup.array().of(pricingRuleValidation),
    otherwise: Yup.array(),
  }),
  apiPricingRules: Yup.array().when("licenceType", {
    is: (value: string) => value === LicenceType.API.toString(),
    then: Yup.array().of(
      Yup.object().shape({
        pricingRules: Yup.array().of(pricingRuleValidation),
      }),
    ),
    otherwise: Yup.array(),
  }),
});

export const featureStepSchema = Yup.object().shape({
  [SoftwareLicenceKeys.FEATURE_HTML]: Yup.string().required(validationMsgs.required),
});

export const licenceTypeSchemeValidation = generalStepSchema
  .concat(specificStepSchema)
  .concat(pricingStepSchema)
  .concat(featureStepSchema);
